import { vaultGetRequest } from '../helpers';
import type { IFetchQueueResponse } from './fetch-queue-response';
import { fetchQueueResponseSchema } from './fetch-queue-response';

export async function fetchQueueApi(): Promise<IFetchQueueResponse> {
  return vaultGetRequest({ path: '/upload/queue', schema: fetchQueueResponseSchema });
}
